import type { OnInit } from '@angular/core';
import {
  ChangeDetectorRef,
  Component,
  EventEmitter,
  inject,
  ChangeDetectionStrategy,
} from '@angular/core';

import { deepEqual } from 'fast-equals';
import { Subject } from 'rxjs';
import { distinctUntilChanged, takeUntil } from 'rxjs/operators';

import { filterBoolean } from '@core/common-legacy';
import { ComponentTooltipService, BaseTooltipComponent } from '@core/product-updates-smart-ui';
import { ArrowPosition } from '@core/user-interface-types';

import { FeatureTooltipData } from './../../types';
import { FeatureTooltipComponent } from '../../ui/feature-tooltip/feature-tooltip.component';

@Component({
  selector: 'rt-feature-tooltip-wrapper',
  templateUrl: './feature-tooltip-wrapper.component.html',
  styleUrls: ['./feature-tooltip-wrapper.component.less'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [FeatureTooltipComponent],
})
export class FeatureTooltipWrapperComponent extends BaseTooltipComponent implements OnInit {
  private readonly cdRef = inject(ChangeDetectorRef);
  private readonly componentTooltipService =
    inject<ComponentTooltipService<typeof FeatureTooltipWrapperComponent, FeatureTooltipData>>(
      ComponentTooltipService,
    );

  public data: FeatureTooltipData;
  public arrowPosition: ArrowPosition;

  public close$ = new EventEmitter<void>();
  public ctaClick$ = new EventEmitter<void>();
  public learnMoreClick$ = new EventEmitter<void>();

  public ngOnDestroy$ = new Subject<void>();

  public ngOnInit(): void {
    this.componentTooltipService.data$
      .pipe(
        distinctUntilChanged((a, b) => deepEqual(a, b)),
        filterBoolean,
        takeUntil(this.ngOnDestroy$),
      )
      .subscribe(data => {
        this.data = data;
        this.cdRef.detectChanges();
      });
  }

  public updateArrow(arrowPosition: ArrowPosition): void {
    this.arrowPosition = arrowPosition;
  }
}
